import { useQuery } from '@tanstack/react-query'
import { useStoProject } from './useStoProject'
import { stoQueries } from './queries/stoQueries'
import { resolveSectionState, type SectionState } from 'models/stoSection'
import { pickContent, StoContentTypes, type BorrowerContent } from 'models/projectContent'

/** The loan calculator's section: only where back-office switches the borrow tab on (funds). */
export function useBorrow(): SectionState<true> {
  const { projectId } = useStoProject()
  const query = useQuery(stoQueries.content(projectId))
  const content = pickContent<BorrowerContent>(query.data, StoContentTypes.BORROWER)

  return resolveSectionState({
    declaredVisible: content?.isTabVisible === true,
    isPending: query.isPending,
    isError: query.isError,
    data: true,
    isEmpty: () => false,
  })
}
